import Router from 'next/router';
import { connect } from 'react-redux';
import { Icon } from '@bridebook/aura';
import { HeartOutline } from '@bridebook/aura/src/icons';
import { A, Button } from '@bridebook/ui';
import { Link } from '@bridebook/web/app-shared/components/link/link';
import { NavigationDestination } from '@bridebook/web/lib/analyticsTypes';
import getAuthStatus from '@bridebook/web/lib/auth/utils/get-auth-status';
import { ConnectedTypes, IApplicationState } from '@bridebook/web/lib/types';
import { usedHeaderNavigation } from '@bridebook/web/lib/ui/actions';
import { UrlHelper } from '@bridebook/web/lib/url-helper';

const storeEnhancer = connect((state: IApplicationState) => ({
  isLoggedIn: getAuthStatus({ user: state.users.user }),
}));

interface IProps extends ConnectedTypes<typeof storeEnhancer> {}

const TopBarShortlist = ({ isLoggedIn, dispatch }: IProps) => {
  const clickHeaderShortlistButton = () => {
    dispatch(usedHeaderNavigation('shortlist' as NavigationDestination));
    Router.push(UrlHelper.shortlist.main);
  };

  const button = (
    <Button
      theme="ghost"
      color="white"
      icon={<Icon icon={HeartOutline} size={24} className="text-white" />}
      onClick={clickHeaderShortlistButton}
    />
  );

  return isLoggedIn ? (
    button
  ) : (
    <Link href="/" passHref legacyBehavior>
      <A>{button}</A>
    </Link>
  );
};

export default storeEnhancer(TopBarShortlist);
